import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '@repo/common';
import { ReactComponent as NavigationRightIcon } from '@repo/common/assets/icons/16px/icon_16px_navigation-right.svg';

function ComingSoonPage({
  title,
  titleKr,
  description,
  descriptionKr,
  embedded = false,
}) {
  const t = useT();
  const Wrapper = embedded ? 'section' : 'main';

  return (
    <Wrapper
      className={
        embedded
          ? 'flex h-full min-h-[320px] w-full flex-1 flex-col items-center justify-center px-4 py-20'
          : 'flex min-h-[60vh] w-full flex-1 flex-col items-center justify-center bg-grayscale-gray01 px-4 py-20 tabletH:px-10 tabletV:px-[50px] desktopL:px-20'
      }
    >
      <div className='flex max-w-[420px] flex-col items-center gap-2 text-center [word-break:break-word]'>
        <p className='typo-b18Strong text-text-primary tabletH:typo-h7'>
          {t(title ?? 'Coming Soon', titleKr ?? '준비 중입니다')}
        </p>
        <p className='typo-b12 text-text-secondary tabletH:typo-b14'>
          {t(
            description ?? "We're getting this page ready. Please check back soon.",
            descriptionKr ?? '페이지를 준비하고 있어요. 조금만 기다려 주세요.',
          )}
        </p>
        {!embedded && (
          <Link
            to='/'
            className='mt-4 inline-flex items-center gap-1 rounded-full bg-grayscale-gray02 px-4 py-2 typo-b14Strong text-text-primary no-underline transition-colors duration-sm ease hover:bg-grayscale-gray03 motion-reduce:transition-none'
          >
            {t('Go to Home', '홈으로 가기')}
            <NavigationRightIcon aria-hidden='true' className='size-4' />
          </Link>
        )}
      </div>
    </Wrapper>
  );
}

export default ComingSoonPage;
